import { render, staticRenderFns } from "./ConfirmareSemnaturaFisa.vue?vue&type=template&id=70c2809e&scoped=true&"
import script from "./ConfirmareSemnaturaFisa.vue?vue&type=script&lang=js&"
export * from "./ConfirmareSemnaturaFisa.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmareSemnaturaFisa.vue?vue&type=style&index=0&id=70c2809e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2809e",
  null
  
)

export default component.exports